import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { fetchClient } from '@/lib/fetchClient';
import { REST_ENDPOINTS } from '@/constants';
import { authKeys } from './queryKeys';

const currentUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  access: z.enum(['full', 'restricted']),
  role: z.enum(['rm', 'sales', 'offering', 'unknown']),
  isAdmin: z.boolean().default(false),
});

export type CurrentUser = z.infer<typeof currentUserSchema>;

export const meQueryOptions = () => ({
  queryKey: authKeys.me,
  queryFn: ({ signal }: { signal?: AbortSignal }) =>
    fetchClient(REST_ENDPOINTS.ME, { signal })
      .then(r => r.json())
      .then(currentUserSchema.parse),
  staleTime: Infinity,
});

type CurrentUserQueryOptions = Partial<
  Omit<UseQueryOptions<CurrentUser, Error, CurrentUser>, 'queryKey' | 'queryFn'>
>;

export function useCurrentUser(queryOptions: CurrentUserQueryOptions = {}) {
  return useQuery({
    ...meQueryOptions(),
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...queryOptions,
  });
}
